export default "__VITE_ASSET__CQg9YtPq__"